import { Typography } from '@mui/material'
import React from 'react'

export const DetailedReport = ({data}) => {
  return (
    <div className="detailed-report-container mt-7">
        <Typography sx={{fontWeight: "bold", marginBottom: "10px"}} variant="h4">Start of Detailed Report</Typography>
        <Typography sx={{fontWeight: "bold"}} variant="body1">
            Aveti Learning and Smart Class:
        </Typography>
        <Typography>
            Aveti learning Pvt. Ltd. Is a registered company that was founded in 2017 to make vernacular
            education accessible to the children of Odisha through the help of technology. Today Aveti has
            enabled 1000+ schools with state of art digital content in Odia.
        </Typography>
        <Typography sx={{fontWeight: "bold"}} variant="body1">
            Stages and implementation at a school:
        </Typography>
        <ol type='a'>
            <li>
                <Typography>
                    <strong>School Activation: </strong>
                    Based on inputs from district administrators, we activate licenses for schools
                    nd register teachers in the Aveti Learning management system.
                </Typography>
            </li>
            <li>
                <Typography>
                    <strong>Installation at school: </strong>
                    We send our executives to the schools with the content and license details
                    to install at specified smart panels. It typically takes around 90 minutes to set up a smart class.
                </Typography>
            </li>
            <li>
                <Typography>
                    <strong>Teachers Training: </strong>
                    Once the installation is over, we start our teachers capacity building training
                    at the school premise with all teachers. The goal of this training is to ensure that teachers can use
                    Aveti content to supplement the classroom instruction.
                </Typography>
            </li>
            <li>
                <Typography>
                    <strong>Support on WhatsApp: </strong>
                    A school level WhatsApp group is created to support teachers and
                    escalate any technical issues. Our support executives at Bhubaneswar can resolve 80% of issues
                    within 2 hours.
                </Typography>
            </li>
        </ol>
        <Typography sx={{fontWeight: "bold"}}><u>Conclusion:</u></Typography>
        <Typography>
            We seek support from the district administration to instruct the mentioned schools with low usage
            as per Appendix B to comply with the training and if needed we are available for the training again.
        </Typography>
    </div>
  )
}
